import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { collections } from '@/mocks/collections';
import useEditorialMotion from '@/hooks/useEditorialMotion';

type Item = (typeof collections)[number];

function Panel({ c, heightClass, dir, at }: { c: Item; heightClass: string; dir: 'left' | 'right'; at: number }) {
  return (
    <Link to={`/shop?category=${c.id}`} className="group flex flex-col min-w-0 cursor-pointer">
      <div
        className={`w-full ${heightClass} overflow-hidden`}
        data-m-in={dir}
        data-m-at={at}
        data-m-mask={dir === 'left' ? 'left' : undefined}
      >
        <img
          src={c.image}
          width={900}
          height={1200}
          loading="lazy"
          decoding="async"
          alt={`${c.name} — Fleur & Form`}
          title={`${c.name} — Fleur & Form`}
          className="w-full h-full object-cover object-top transition-transform duration-[420ms] ease-out group-hover:scale-[1.025]"
        />
      </div>
      <div className="flex items-baseline justify-between pt-3 md:pt-4" data-m-in="up" data-m-dist="14" data-m-dur="0.6" data-m-at={at + 0.2}>
        <div className="flex items-baseline gap-3">
          <span className="text-[11px] text-black/40">{c.no}</span>
          <span className="text-[18px] md:text-[20px] tracking-[-0.02em]">{c.name}</span>
        </div>
        <span className="text-[12px] md:text-[13px] border-b border-black/30 group-hover:border-black transition-colors duration-200 whitespace-nowrap">
          Shop <span className="inline-block transition-transform duration-[240ms] group-hover:translate-x-1">→</span>
        </span>
      </div>
    </Link>
  );
}

export default function Collection() {
  const ref = useRef<HTMLElement>(null);
  useEditorialMotion(ref);
  const [fresh, dried, objects] = collections;
  return (
    <section ref={ref} id="collection" className="bg-[#FAFAF8] pt-20 md:pt-40 pb-16 md:pb-24">
      <div className="flex flex-wrap items-end justify-between gap-3 px-4 md:px-10 mb-8 md:mb-12">
        <h2 data-m-head className="font-normal tracking-[-0.04em] leading-none text-[40px] md:text-[72px]">The Collection</h2>
        <p data-m-fade data-m-at="0.15" className="ff-serif italic text-[16px] md:text-[18px] text-black/60">Three ways to live with flowers</p>
      </div>
      <div data-m-group className="grid grid-cols-1 md:grid-cols-[3fr_2fr] gap-10 md:gap-6 px-4 md:px-10">
        <Panel c={fresh} heightClass="h-[480px] md:h-[868px]" dir="left" at={0} />
        <div className="flex flex-col gap-10 md:gap-6 min-w-0">
          <Panel c={dried} heightClass="h-[420px] md:h-[400px]" dir="right" at={0.12} />
          <Panel c={objects} heightClass="h-[420px] md:h-[400px]" dir="right" at={0.24} />
        </div>
      </div>
    </section>
  );
}